export default class Utils {
    // Récupérer la valeur d'un cookie par son nom
    static getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; ++i) {
            let pair = cookies[i].trim().split('=');
            if (pair[0] === name) {
                return pair[1];
            }
        }
        return null;
    }

    // Récupérer la valeur d'un cookie avec décodage (version améliorée avec decodeURIComponent)
    static getDecodedCookie(name) {
        const cookieValue = Utils.getCookie(name);
        return cookieValue ? decodeURIComponent(cookieValue) : null;
    }

    // Définir un cookie
    static setCookie(name, value, days = 7, domain = window.location.hostname) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Expiration après X jours
        const expires = "expires=" + date.toUTCString();
        const domainStr = domain ? ";domain=" + domain : "";
        document.cookie = name + "=" + encodeURIComponent(value) + ";" + expires + domainStr + ";path=/";
    }

    // Supprimer un cookie
    static deleteCookie(name, domain = window.location.hostname) {
        const domainStr = domain ? ";domain=" + domain : "";
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/" + domainStr;
    }
}
window.Utils = Utils;
